import { Suspense, lazy } from 'react'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

const JobDetailPage = lazy(() => import('@/pages/jobs/detail'))

export default function EventDetailPage() {
  return (
    <WorkspacePortalProvider mode="event">
      <Suspense fallback={null}>
        <JobDetailPage />
      </Suspense>
    </WorkspacePortalProvider>
  )
}
